import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import api from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { DateRangeField } from "@/components/DateRangeField";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const fieldCls = "w-full h-12 rounded-xl border border-brand-plum/15 bg-white px-3 text-brand-plum text-sm focus:outline-none focus:border-brand-teal";
const labelCls = "block text-[11px] font-semibold uppercase tracking-wider text-brand-plum/50 mb-1.5";

export const SearchWidget = () => {
  const { t } = useLang();
  const navigate = useNavigate();
  const [cities, setCities] = useState([]);
  const [f, setF] = useState({ city: "all", checkin: "", checkout: "", guests: 2 });
  const set = (k, v) => setF((s) => ({ ...s, [k]: v }));

  useEffect(() => {
    api.get("/public/cities").then((r) => setCities(r.data)).catch(() => {});
  }, []);

  const submit = (e) => {
    e.preventDefault();
    const q = new URLSearchParams();
    if (f.city !== "all") q.set("city", f.city);
    if (f.checkin && f.checkout) {
      q.set("checkin", f.checkin);
      q.set("checkout", f.checkout);
    }
    if (f.guests) q.set("guests", String(f.guests));
    navigate(`/case-vacanze?${q.toString()}`);
  };

  return (
    <form onSubmit={submit} data-testid="home-search-widget" className="rounded-2xl bg-white/95 backdrop-blur p-4 md:p-5 shadow-[0_24px_60px_-20px_rgba(20,10,40,0.6)] grid gap-3 sm:grid-cols-2 lg:grid-cols-[1.2fr_1.8fr_0.6fr_auto] items-end max-w-5xl">
      <div>
        <span className={labelCls}>{t("home.wCity")}</span>
        <Select value={f.city} onValueChange={(v) => set("city", v)}>
          <SelectTrigger data-testid="search-city" className="h-12 rounded-xl border-brand-plum/15"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">{t("listing.allCities")}</SelectItem>
            {cities.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div>
        <span className={labelCls}>{t("home.wDates")}</span>
        <DateRangeField checkin={f.checkin} checkout={f.checkout} onChange={(ci, co) => setF((s) => ({ ...s, checkin: ci, checkout: co }))} testid="search-dates" className="h-12 rounded-xl px-3 text-sm" />
      </div>
      <label>
        <span className={labelCls}>{t("home.wGuests")}</span>
        <input type="number" min="1" max="30" value={f.guests} onChange={(e) => set("guests", Math.max(1, parseInt(e.target.value) || 1))} data-testid="search-guests" className={fieldCls} />
      </label>
      <button type="submit" data-testid="home-search-cta" className="h-12 px-7 rounded-xl bg-brand-teal hover:bg-brand-tealDark text-brand-violet font-semibold flex items-center justify-center gap-2 transition-colors sm:col-span-2 lg:col-span-1">
        <Search size={18} /> {t("home.wSearch")}
      </button>
    </form>
  );
};
